import { simpleSet } from '@r/reducers/utils';

export const materialsSets = simpleSet(
  'SET_CALCULATION_MODE_MATERIALS_SETS',
  {
    data: [],
    counter: 0,
    keys: [],
    coreOptions: [],
    doorsDrawersOptions: [],
    edgebandingOptions: []
  }
);
